import { autoFixUiConfig } from 'helpers/uiConfig.helper/uiConfigReviewer/uiConfigReviewer'
import React, { useMemo } from 'react'

export function useAutoFixManyUiConfigs({ uiConfigs }: { uiConfigs: UiConfig[] }) {
  const res = useMemo(() => {
    return uiConfigs.map((uiConfig) => autoFixUiConfig(uiConfig))
  }, [uiConfigs])
  return res
}

export default function useAutoFixUiConfig({ uiConfig }: { uiConfig: UiConfig | null | undefined }) {
  const res = useMemo(() => {
    return autoFixUiConfig(uiConfig)
  }, [uiConfig])
  return res
}
